import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { ExitReleaseFocus } from './exitReleaseFocus';
import { ClearMultiselection } from './cardSelection/clearMultiselection';
import { SetReleaseIsCollapsed } from './releases/setReleaseIsCollapsed';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class FocusRelease extends Action<StorymapState> {
    public static ACTION_TYPE = 'FocusRelease';

    public constructor(public releaseId: string) {
        super(FocusRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: FocusRelease): Promise<boolean> => {
    dispatch(new ClearMultiselection());
    dispatch(new SetReleaseIsCollapsed(action.releaseId, false));
    return await dispatch(new ExitReleaseFocus());
};

const reducer = (state: StorymapState, action: FocusRelease): void => {
    // Clear hide-unfiltered when focusing a release (mutual exclusivity)
    state.filterState.hideUnfiltered = false;

    const release = state.releases.find(x => x.id == action.releaseId);
    release.isFocused = true;
};

//@ts-ignore
registerMiddleware(FocusRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(FocusRelease.ACTION_TYPE, reducer);